module.exports = __webpack_public_path__ + "img/button.5c74d8da.gif";